module.exports = __webpack_public_path__ + "img/double-arrow.67e8bfd9.svg";